import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-24 bg-white text-center" data-id="element-26">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-28">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-29">
            If you're tired of guessing today...
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-30">
            And you need a plan you can see and follow without breaking down
            inside:
          </p>

          <Button size="lg" withIcon className="shadow-xl hover:shadow-2xl transform hover:-translate-y-1" data-id="element-31">
            Download The NDIS Autism Plan Builder
          </Button>

          <p className="mt-6 text-sm text-gray-400" data-id="element-32">
            Start building your 4 maps this week.
          </p>
        </motion.div>
      </div>
    </section>;
}